import React, { FC } from 'react';

import { formatZip } from '../utilities/formatting';

import { TextInput, TextInputProps } from './TextInput';

/* ZipCodeTextInput */
// Formats incoming text longer than 5 digits to 9 digit format with hyphen
// Retains format when passing value to form handler

export const ZipCodeTextInput: FC<TextInputProps> = ({ ...props }) => {
  const handleZipCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { onChange } = props;
    const formattedZip = formatZip(e.target.value.toString());
    e.target.value = formattedZip;
    onChange(e);
  };

  return <TextInput {...props} onChange={handleZipCodeChange} />;
};
